//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import AQDialog from "../../../../../components/Generics/AQDialog/AQDialog.vue";
import AQButton from "../../../../../components/Generics/AQButton/AQButton.vue";

export default {
    components: {
        AQDialog,
        AQButton
    },
    data() {
        return {
            dialog: false,
            alert: false,
            lengthyDialog: false,
            lengthyAlert: false,
            confirmEvents: false,
            confirmLabelEvents: false,
            deleteAlert: false,
            threeBtnAlert: false,
            actionAlert: false
        };
    },
    computed: {

    },
    methods: {
        okConfirm() {
            alert("Ok has been pressed");
        },
        cancelConfirm() {
            alert("Cancel has been pressed");
        },
        action() {
            alert("Your action has been triggered");
        }
    }
};
